import { IEntityID, IEntitySearchDoc } from './../ts/rlAdmin.models';
import { IdBuilder, AclUtil } from './../ts/rlAdmin.utils';
import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as moment from "moment";
import { NotifyService } from "../services/notify-service";
import { EntityService } from "../services/entity-service";
import { EventService } from "../services/event-service";
import { AccountService } from "../services/account-service";
import { AclService } from "../services/acl-service";
import { DateLocaleService } from "../services/date-locale-service";
import { ContractService } from "../services/contract-service";
import { ModalService } from "../services/modal-service";
import { WorkflowService } from "../services/workflow-service";
import { AdminService } from "../services/admin-service";
import { EntityConfigService } from "../services/entity-config-service";
import { CustomViewsService } from "../services/custom-views-service";

import { ListService } from "../services/list-service";
import { ContactService } from "../services/contact-service";
import angular = require('angular');
import { RightService } from '../services/rights-service';
import { IOnApplyFiltersEvent } from "../components/list-column-filter.component";
import { SearchService } from "../services/search-service";

export function RLRights() {
    var directive: ng.IDirective = {
        template: require("/assets/app/templates/rights.html"),
        replace: true,
        transclude: true,
        scope: {
            parentEntityId: "@",
            rights: "=?",
            canEdit: "=",
            initialized: "=",
            canSelect: "@",
            selectedEntities: "=?",
            forceRefresh: "=?",
            newRightsIDs: "=?newRightsIds",
            parentRecordLocked: "=",
            rightsDefaults: "=?",
            templateColors: "=?",
            onDataChanged: "&?"
        },
        controllerAs: "rVM",
        controller: RLRightsController,
        bindToController: true
    };
    return directive;
}

enum BulkAssociationMode {
    Replace = 0,
    Add = 1,
    Remove = 2
}

const PAGE_DEFAULT = 1;
const ROWCOUNT_DEFAULT = 10;
const SORTDIR_DEFAULT = 0;

class RLRightsController {

    static $inject = ["$scope",
        "$rootScope",
        "$filter",
        "$window",
        "$q",
        "$timeout",
        "$interval",
        "notifyService",
        "dateLocaleService",
        "entityService",
        "contractService",
        "modalService",
        "workflowService",
        "eventService",
        "entityConfigService",
        "accountService",
        "aclService",
        "adminService",
        "contactService",
        "rightService",
        "customViewsService",
        "listService",
        "searchService"
    ];

    groupedRows: _.Dictionary<Models.IListTableRow[]> = {};

    divID: number;
    charTypeID: number;
    parentRecID: number;
    parentEntityId: string;

    selectedEntities: (Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair)[] = [];

    rights: (Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair)[] = [];
    rightsRelationshipIDs: { [rightSetID: string]: string } = {};
    templateMetaData: { [templateID: string]: Models.ICharacteristicMetaDataCollection };
    lovs: { [label: string]: Models.ICharLovMetaData } = {};
    lovCMDs: Models.ICharacteristicMetaData[] = [];
    selectedRights: { [groupName: string]: Models.IListTableRow[] } = {};
    selectedRightsIDs: {
        [groupName: string]: string[]
    } = {};

    initialized: boolean = false;
    visibility: number = 1;
    locked: number = 0;
    canEdit: boolean;
    showPreview: boolean = true;
    canSelect: boolean;
    // APPEARS TO NOT BE USED, 1 REF IN RIGHTS.HTML
    hideUsageCreateButton = true;
    hadRights: boolean = false;

    selectedCatalogItems: Models.IEntity[];

    forceRefresh: boolean;
    forceUsageRefresh: { [rightSetID: string]: boolean } = {};

    newRightsIDs: string[];
    parentRecordLocked: boolean;
    catalogTitleDictionary: { [key: number]: string } = {};
    rightSetCatalogTitlesDictionary: { [key: string]: Models.IKeyValuePair<number, string>[] } = {};
    showRightSetCatalogItemsTD: boolean = false;


    showJobProgressStatus: boolean = false;
    jobId: string = "";
    jobTitle: string = "";
    jobTemplateID: number;
    progressStatus: string;

    dataDefaultLabel: string = "";
    showSaveDefaultsModal: boolean = false;
    rightsDefaults: Models.IDataDefaultSet[];
    expandedRights: { [rightsetID: string]: boolean } = {};
    usageTemplates: { [rightsetTemplateID: string]: Models.ICharacteristicTemplate[] } = {};

    /* ADD ALL BELOW TO MODAL SERVICE */
    lovMetaDatas: {
        [groupName: string]: {
            [charValueSourceID: string]: Models.ICharLovMetaData
        }
    } = {};

    hasLockedRecordsSelected: { [groupName: string]: boolean } = {};
    hasUndeletableRecordsSelected: { [groupName: string]: boolean } = {};

    bulkEditDatesModalOpen: boolean = false;
    bulkEditDateMode: string = "set";
    bulkEditDateSetStart: string;
    bulkEditDateSetEnd: string;
    bulkEditDateAdjustStart: number;
    bulkEditDateAdjustEnd: number;
    bulkEditTemplate: string;

    bulkEditDateStartCmd: Models.ICharacteristicMetaData;
    bulkEditDateEndCmd: Models.ICharacteristicMetaData;
    bulkEditDatesDescription: string = "";
    bulkEditDateSetDateValidators: { [key: string]: (value: string) => boolean } = {
        "invalid-date": (value) => {
            var valid = true;
            if (value) {
                var date = moment(value, "MM/DD/YYYY");
                valid = date.isValid();
            }
            return valid;
        },
        "invalid-date-pair": (value) => {
            var valid = true;
            if (this.bulkEditDateSetStart && this.bulkEditDateSetEnd) {
                var startDate = moment(this.bulkEditDateSetStart, "MM/DD/YYYY");
                var endDate = moment(this.bulkEditDateSetEnd, "MM/DD/YYYY");

                if (startDate.isValid() && endDate.isValid()) {
                    if (startDate >= endDate) {
                        valid = false;
                    }
                }
            }
            return valid;
        }
    };

    bulkEditDateSetDatePairValidator: { [key: string]: (value: string) => boolean } = {
        "required-set-dates": (value) => {
            var valid = true;

            if (value == "set") {
                var startDate = moment(this.bulkEditDateSetStart, "MM/DD/YYYY");
                var endDate = moment(this.bulkEditDateSetEnd, "MM/DD/YYYY");

                valid = startDate.isValid() || endDate.isValid();
            }

            return valid;
        }
    };

    bulkEditDateAdjustDatePairValidator: { [key: string]: (value: string) => boolean } = {
        "required-adjust-dates": (value) => {
            var valid = true;

            if (value == "adjust") {
                var adjustStart = this.bulkEditDateAdjustStart || 0;
                var adjustEnd = this.bulkEditDateAdjustEnd || 0;
                valid = adjustStart != 0 || adjustEnd != 0;
            }

            return valid;
        }
    };

    // bulk edit hierarchies
    bulkEditHierarchyEditCmds: { [groupName: string]: Models.ICharacteristicMetaData[] } = {};
    bulkEditHierarchyModalOpen: boolean = false;
    bulkEditHierarchyCmd: Models.ICharacteristicMetaData;
    bulkEditHierarchyMode: Consts.BulkEditHierarhcyMode.Replace;
    bulkEditHierarchyValueIDs: number[] = [];
    bulkEditHierarchyLOVs: Models.ICharacteristicMetaDataValue[] = [];
    bulkEditHierarchyFilter: string = "";
    bulkEditHierarchyValidateLovs: { [key: string]: (value: number[]) => boolean } = {
        "required": (value) => {
            return (value != null && value.length > 0);
        }
    };
    bulkEditHierarchyModeEnum = Consts.BulkEditHierarhcyMode;

    // bulk delete
    bulkDeleteModalOpen: boolean = false;
    bulkDeleteValidateConfirm: { [key: string]: (value: string) => boolean } = {
        "confirm": (value: string) => {
            return (value || "").toUpperCase() == "DELETE";
        }
    };
    deleteConfirmText: string;

    //bulkEditStatus
    bulkEditStatusModalOpen: boolean = false;
    bulkCanEditStatus: boolean = false;
    bulkWorkflowActions: {
        [templateName: string]: Models.IWFAction[]
    } = {};
    bulkEditActionID: number = null;
    /* END ADD TO MODAL SERVICE */

    bulkEditAssociationsModalOpen: boolean = false;
    bulkRightsTemplateID: number;
    bulkCatalogItems: Models.IEntitySearchDoc[] = [];
    bulkExistingRelationships: Models.IEntityRelationship[] = [];
    bulkCatalogAssociationMode: BulkAssociationMode = BulkAssociationMode.Replace;

    relatedChildCharTypeIDs: number[] = [];

    rightProperties: { [entityID: string]: Models.IEntityID } = {};

    rightTransactions: { [entityID: string]: Models.IEntityID } = {};
    rightsDealIds: number[] = [];
    rightsDealsDictionary: { [dealId: string]: { dealName: string, primaryContactId: number, primaryContactName: string } } = {};

    groupPages: {
        [groupName: string]: { page?: number, pageCount?: number, rowCount?: number, numFound?: number, sortDir?: number, sortField?: string }
    } = {};

    titleKeywords: {
        [groupName: string]: string
    } = {};

    dateRanges: {
        [groupName: string]: {
            startDate: string;
            endDate: string;
        }
    } = {};

    customColumns: { [templateName: string]: Models.ICustomUserColumns };
    availableColumns: Models.IListTableColumn[];

    filterValues: {
        [groupName: string]: { [solrLabel: string]: string[] }
    } = {};
    selectedFilters: {
        [groupName: string]: {
            [tagLabel: string]: { [value: string]: boolean }
        }
    } = {};
    filtersEnabled: {
        [groupName: string]: boolean
    } = {};
    groupByMethod: string = "chartypeid";

    /* LOV Filters */
    selectedPaths: { [label: string]: string[] } = {};

    csvExportJobID: string;
    csvExportProgressIntervalPromise: ng.IPromise<any>;

    contactTitlesDictionary: { [key: number]: string } = {};
    rightSetContactTitlesDictionary: { [key: string]: Models.IKeyValuePair<number, string>[] } = {};
    showRightSetContactsTD: boolean = false;
    entityContacts: Models.IEntityRelationshipPair[] = [];
    parentCurrencyCharData: Models.ICharDataValue;
    templateColors: { [key: number]: string };
    onDataChanged: (event: { parentEntityID: string }) => any;
    allUsageTemplateDefaults: Models.IDataDefaultSet[] = [];
    usageTemplateDataDefaultSets: { [rightsetTemplateID: string]: Models.IDataDefaultSet[] } = {};
    relChildCharTypeID: number = Consts.CharTypeIDs.right;
    currentPreviewEntityID: string;
    SORTFIELD_DEFAULT: string;

    public isLoading: boolean = false;

    //Drag and Drop
    sortableOptions: any = {
        containment: '#rights-table',
        containerPositioning: 'relative',
        accept: function (sourceItemHandleScope, destSortableScope) {
            return sourceItemHandleScope.itemScope.sortableScope.$parent.groupName === destSortableScope.$parent.groupName;
        },
        orderChanged: (event) => {
            this.UpdateOrder(event);
        }
    };

    rightSetRecordSequence: { [recordID: number]: number } = {};
    usageCounts: { [id: string]: number } = {};

    public constructor(
        private readonly $scope: ng.IScope,
        private readonly $rootScope: ng.IRootScopeService,
        private readonly $filter: ng.IFilterService,
        private readonly $window: ng.IWindowService,
        private readonly $q: ng.IQService,
        private readonly $timeout: ng.ITimeoutService,
        private readonly $interval: ng.IIntervalService,
        private readonly notifyService: NotifyService,
        private readonly dateLocaleService: DateLocaleService,
        private readonly entityService: EntityService,
        private readonly contractService: ContractService,
        private readonly modalService: ModalService,
        private readonly workflowService: WorkflowService,
        private readonly eventService: EventService,
        private readonly entityConfigService: EntityConfigService,
        private readonly accountService: AccountService,
        private readonly aclService: AclService,
        private readonly adminService: AdminService,
        private readonly contactService: ContactService,
        private readonly rightService: RightService,
        private readonly customViewsService: CustomViewsService,
        private readonly listService: ListService,
        private readonly searchService: SearchService) {

        $scope.$watch(() => this.selectedPaths, (newValue) => {
            if (!_.isEmpty(newValue)) {
                var keys = _.keys(newValue);
                var runGetRightsSearch = false;

                runGetRightsSearch = keys.some(function (key) {
                    return newValue[key].length > 0;
                });

                if (runGetRightsSearch) {
                    let groupedRows = this.groupedRows;
                    for (var group in groupedRows) {
                        if (groupedRows.hasOwnProperty(group)) {
                            this.GetRights(group, this.getFilters(group));
                        }
                    }
                }
            }
        }, true);

        $scope.$watch(() => this.groupByMethod, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.groupPages = {};
                this.groupedRows = {};
                this.selectedRights = {};
                this.selectedRightsIDs = {};
                this.GetRights();
            }
        });

        $scope.$watch(() => this.filtersEnabled, (newValue, oldValue) => {
            if (newValue) {
                for (var groupName in newValue) {
                    if (newValue[groupName]) {
                        if (!oldValue || !oldValue[groupName]) {
                            if (this.charTypeID == Consts.CharTypeIDs.transaction) {
                                this.loadContractFilters(groupName);
                            } else if (this.charTypeID == Consts.CharTypeIDs.property) {
                                this.loadCatalogFilters(groupName);
                            }
                        }
                    } else if (oldValue && oldValue[groupName]) {
                        this.selectedFilters[groupName] = {};
                        this.GetRights(groupName);
                    }
                }
            }
        }, true);

        $scope.$watch(() => this.forceRefresh, (newValue) => {
            if (newValue) {
                // per group to preserve unique group paging
                if (Object.keys(this.groupedRows).length > 0) {
                    for (var groupName in this.groupedRows) {
                        this.GetRights(groupName, this.getFilters(groupName))
                            .then(() => {
                                this.forceRefresh = false;
                            });
                    }
                } else {
                    this.GetRights()
                        .then(() => {
                            this.forceRefresh = false;
                        });
                }
            }
        });

        $scope.$watch(() => this.groupPages, (newValue, oldValue) => {
            if (oldValue) {
                for (var groupName in newValue) {
                    if (oldValue[groupName]) {
                        if (newValue[groupName].page != oldValue[groupName].page || newValue[groupName].rowCount != oldValue[groupName].rowCount
                            || newValue[groupName].sortDir != oldValue[groupName].sortDir || newValue[groupName].sortField != oldValue[groupName].sortField) {
                            this.GetRights(groupName, this.getFilters(groupName));
                        }
                    }
                }
            }
        }, true);

        $scope.$watch(() => this.titleKeywords, (newValue, oldValue) => {
            if (newValue) {
                for (let groupName in newValue) {
                    if (!oldValue || newValue[groupName] != oldValue[groupName]) {
                        this.GetRights(groupName, this.getFilters(groupName));
                    }
                }
            }
        }, true);

        $scope.$watch(() => this.dateRanges, (newValue, oldValue) => {
            if (newValue) {
                for (let groupName in newValue) {
                    if (!oldValue || !oldValue[groupName] || newValue[groupName].startDate != oldValue[groupName].startDate
                        || newValue[groupName].endDate != oldValue[groupName].endDate) {
                        this.clearRights(groupName);
                        this.GetRights(groupName, this.getFilters(groupName));
                    }
                }
            }
        }, true);

        $scope.$watch(() => this.customColumns, (newValue, oldValue) => {
            if (newValue) {
                if (_.keys(newValue).length >= _.keys(this.groupedRows).length) {
                    for (let groupName in this.customColumns) {
                        if (!oldValue || !oldValue[groupName] || _.keys(newValue).length != _.keys(oldValue).length
                            || newValue[groupName].name != oldValue[groupName].name) {
                            this.setupRows(groupName);
                        } else if (oldValue && _.keys(newValue).length == _.keys(oldValue).length) {
                            var newColumns = newValue[groupName].columns.map((col) => { return col.label; });
                            var oldColumns = oldValue[groupName].columns.map((col) => { return col.label; });

                            var diff = _.difference(newColumns, oldColumns);
                            if (diff.length > 0) {
                                this.setupRows(groupName);

                                // If new custom columns have been set and other templates are on the 'Visible Characteristics' default then lets set those too
                                _.forOwn(this.customColumns, (columns, groupName) => {
                                    if (groupName != groupName && columns.name == "Visible Characteristics") {
                                        this.customColumns[groupName] = this.customColumns[groupName];
                                    }
                                });
                                break;
                            }
                        }
                    }
                }
                if (this.charTypeID == Consts.CharTypeIDs.transaction) {
                    this.getDeals([this.parentRecID]);
                } else if (this.charTypeID == Consts.CharTypeIDs.property) {
                    this.getDeals(this.rightsDealIds);
                    this.associateSpecialCatalogColumns(this);
                }
            }
        }, true);

        $scope.$watch(() => this.selectedRights, (newValue) => {
            if (newValue) {
                _.forOwn(this.selectedRights, (rights, groupName) => {
                    this.selectedRightsIDs[groupName] = this.selectedRights[groupName].map(right => {
                        return right.entityID;
                    });

                    this.hasLockedRecordsSelected[groupName] = _.any(this.selectedRights[groupName], (right) => {
                        return right.lockedIndicator;
                    });

                    this.hasUndeletableRecordsSelected[groupName] = _.any(this.selectedRights[groupName], (right) => {
                        return !right.deleteIndicator;
                    });
                });
            }
        }, true);

        $scope.$watch(() => this.parentEntityId, (newValue, oldValue) => {
            if (newValue) {
                var split = Utils.IdBuilder.splitEntityID(newValue);
                this.divID = split.divID;
                this.charTypeID = split.charTypeID;
                if (this.charTypeID == Consts.CharTypeIDs.transaction) {
                    this.SORTFIELD_DEFAULT = "table_sequence";
                } else {
                    this.SORTFIELD_DEFAULT = "title_sort";
                }
                this.parentRecID = split.recID;
                this.Init()
                    .then(() => {
                        this.initialized = true;
                        this.GetRights();
                    });
            }
        });

        $scope.$watch(() => this.newRightsIDs, (newValue, oldValue) => {
            if (newValue != oldValue && newValue.length > 0) {
                this.GetRights();
                this.forceRefresh = false;
            }
        });

        $scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
            if (newValue != oldValue && newValue == "Done") {
                this.GetRights().then(() => {
                    this.showJobProgressStatus = false;
                    this.jobTemplateID = undefined;
                    this.jobTitle = undefined;
                });
            }
        });

        /* REPLACE WITH MODAL SERVICE AND NO NEED TO RESET */
        // reseting bulk edit data form when modal closes
        $scope.$watch(() => this.bulkEditDatesModalOpen,
            (newValue, oldValue) => {
                if (!newValue && oldValue) {
                    this.bulkEditDateMode = "set";
                    this.bulkEditDateSetStart = null;
                    this.bulkEditDateSetEnd = null;
                    this.bulkEditDateAdjustEnd = null;
                    this.bulkEditDateAdjustStart = null;
                    this.bulkEditDateStartCmd = null;
                    this.bulkEditDateEndCmd = null;
                }
            });

        /* reset values of non-selected bulk edit date mode values in bulk edit date modal */
        $scope.$watch(() => this.bulkEditDateMode,
            (newValue, oldValue) => {
                if (newValue != oldValue) {
                    if (newValue == "set") {
                        this.bulkEditDateAdjustEnd = null;
                        this.bulkEditDateAdjustStart = null;
                    } else if (newValue == "adjust") {
                        this.bulkEditDateSetStart = null;
                        this.bulkEditDateSetEnd = null;
                    }
                }
            });

        /* update bulk edit date description whenever any of the modal form values change */
        $scope.$watch(() => [this.bulkEditDateMode, this.bulkEditDateSetStart, this.bulkEditDateSetEnd, this.bulkEditDateAdjustEnd, this.bulkEditDateAdjustStart],
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.bulkEditDatesDescription = this.GenerateDescription(this.bulkEditTemplate);
                }
            }, true);

        /* reseting bulk hierarchy modal when modal closes  */
        $scope.$watch(() => this.bulkEditHierarchyModalOpen,
            (newValue, oldValue) => {
                if (!newValue && oldValue) {
                    this.bulkEditHierarchyCmd = null;
                    this.bulkEditHierarchyMode = Consts.BulkEditHierarhcyMode.Replace;
                    this.bulkEditHierarchyValueIDs = [];
                    this.bulkEditHierarchyLOVs = [];
                    this.bulkEditHierarchyFilter = "";
                }
            });

        $scope.$watch(() => this.bulkDeleteModalOpen,
            (newValue, oldValue) => {
                if (!newValue && oldValue) {
                    this.deleteConfirmText = "";
                }
            });

        $scope.$on(Consts.Events.RefreshViewEntity, (e, data) => {
            this.currentPreviewEntityID = data;
        });
    }

    private canDeleteResults: _.Dictionary<boolean> = {};
    private canEditResults: _.Dictionary<boolean> = {};

    ViewRightset(entityID: string) {
        let rightSet = _.find(this.rights, (right) => {
            return right.document.entityID == entityID;
        });

        this.entityService.getEntity(rightSet.document.entityID)
            .then((res) => {
                let newEntityRelationshipPair = <Models.INestedRelationshipPair>res;
                newEntityRelationshipPair.relationship = rightSet.relationship;
                newEntityRelationshipPair.assetRels = (<any>rightSet).assetRels;
                newEntityRelationshipPair.contactRels = (<any>rightSet).contactRels;
                this.currentPreviewEntityID = entityID;
                this.$rootScope.$broadcast(Consts.Events.ViewEntityRelationshipPair, newEntityRelationshipPair);
            });
    }

    NewUsage(parentRightSetID: string, usageTemplate: Models.ICharacteristicTemplate, $event: ng.IAngularEvent) {
        $event.preventDefault();

        const relationship = this.GetRelationship(parentRightSetID);

        this.modalService.createEntityByTemplate(Utils.IdBuilder.buildTemplateID(0, Consts.CharTypeIDs.usage, usageTemplate.templateID), Utils.IdBuilder.buildRelationshipID(relationship), null, [Consts.CharTypeIDs.property])
            .then((charDataCollection) => {
                if (charDataCollection != undefined) {
                    this.forceRefresh = true;
                }
            });
    }

    GetRelationship(entityID: string) {
        const rightSet = _.find(this.rights, (right) => {
            return right.document.entityID === entityID;
        });

        return rightSet.relationship;
    }

    ToggleSelectAllRows(groupName: string) {
        if (this.groupedRows[groupName].length == this.selectedRights[groupName].length) {
            this.selectedRights[groupName] = [];
        } else {
            this.selectedRights[groupName] = [];
            this.groupedRows[groupName].forEach((row) => {
                this.selectedRights[groupName].push(row);
            });
        }
    }

    private getRightEntity(entityID: string) {
        return this.entityService.getEntityCharData(entityID);
    }

    EditRightset(rightEntityID: string) {
        let rightSet = _.find(this.rights, (right) => {
            return right.document.entityID == rightEntityID;
        });
        this.getRightEntity(rightSet.document.entityID)
            .then((res) => {
                var assetRels = (<any>rightSet).assetRels;
                var contactRels = (<any>rightSet).contactRels;
                var allRels: any;

                var childCharTypeIDs: number[] = [];
                var parentCharTypeID = Utils.IdBuilder.splitEntityID(this.parentEntityId).charTypeID;

                if (parentCharTypeID == Consts.CharTypeIDs.transaction) {
                    allRels = assetRels.concat(contactRels);
                    childCharTypeIDs.push(Consts.CharTypeIDs.property);
                    childCharTypeIDs.push(Consts.CharTypeIDs.user);
                } else {
                    allRels = contactRels;
                    childCharTypeIDs.push(Consts.CharTypeIDs.user);
                }

                this.modalService.editEntityWithRelationships(res, this.parentEntityId, undefined,
                    allRels, Utils.IdBuilder.buildRelationshipID(rightSet.relationship), childCharTypeIDs)
                    .then((charDataCollection) => {
                        this.notifyService.notifySuccess("Rights Saved");
                        this.onDataChanged({ parentEntityID: this.parentEntityId });
                        for (var groupName in this.groupedRows) {
                            this.GetRights(groupName, this.getFilters(groupName), rightSet.document.entityID);
                        }
                    }).catch(angular.noop);
            });
    }

    private getFilters(groupName: string): _.Dictionary<string[]> {
        if (!this.selectedFilters[groupName]) {
            return {};
        }
        let filters = Object.keys(this.selectedFilters[groupName])
            .reduce<_.Dictionary<string[]>>(
                (result, tagLabel) => {
                    let allValues = Object.keys(this.selectedFilters[groupName][tagLabel])
                    let activeValues = allValues.filter(value => this.selectedFilters[groupName][tagLabel][value]);
                    if (allValues.length !== activeValues.length) {
                        result[tagLabel] = activeValues;
                    }
                    return result;
                }, {});
        return filters;
    }

    private loadCatalogFilters(groupName: string) {
        let solrLabels = this.getFacetSolrLabels(groupName);
        let parentRecID = Utils.IdBuilder.splitEntityID(this.parentEntityId).recID;

        this.entityService.searchCatalogRights(
            parentRecID,
            undefined,
            undefined,
            undefined,
            undefined,
            solrLabels,
            1,
            0,
            undefined,
            undefined,
            this.groupByMethod,
            this.getGroupID(groupName),
            this.selectedPaths)
            .then((res) => {
                var fac = res.facetResults;
                this.resetFilters(groupName, fac);
            });
    }

    private loadContractFilters(groupName: string) {
        let solrLabels = this.getFacetSolrLabels(groupName);
        let parentRecID = Utils.IdBuilder.splitEntityID(this.parentEntityId).recID;

        this.contractService.getContractRights(
            parentRecID,
            undefined,
            undefined,
            undefined,
            undefined,
            solrLabels,
            1,
            0,
            undefined,
            undefined,
            this.groupByMethod,
            undefined,
            this.selectedPaths)
            .then((res) => {
                var fac = res.facetResults;
                this.resetFilters(groupName, fac);
            });
    }

    private resetFilters(groupName: string, fac: { [key: string]: Models.ISearchFacet[]; }) {
        this.filterValues[groupName] = {};
        this.selectedFilters[groupName] = {};
        for (var solrLabel in fac) {
            if (fac[solrLabel].length > 0) {
                this.filterValues[groupName][solrLabel] = [];
                this.filterValues[groupName][solrLabel] = _.map(fac[solrLabel], (val) => {
                    return val.key;
                });
                if (this.filterValues[groupName][solrLabel]) {
                    if (!this.selectedFilters[groupName][solrLabel]) {
                        let filter = {
                            "NULL": true
                        };
                        let filterKeys = this.filterValues[groupName][solrLabel];
                        filterKeys.forEach(key => {
                            filter[key] = true;
                        });
                        this.selectedFilters[groupName][solrLabel] = filter;
                    }
                }
            }
        }
        this.GetRights(groupName);
    }

    private getUniqueTemplates(groupName: string) {
        let uniqueTemplateIDs: number[];
        for (var group in this.groupedRows) {
            uniqueTemplateIDs = _.chain(this.groupedRows[groupName]).map((row) => { return row.templateID; }).uniq().valueOf();
        }
        return uniqueTemplateIDs;
    }

    private getFacetSolrLabels(groupName: string): string[] {
        var solrLabels: string[] = [];

        solrLabels.push("last_updated");
        solrLabels.push("status");

        let uniqueTemplates = this.getUniqueTemplates(groupName);

        uniqueTemplates.forEach((templateID) => {
            Utils.AclUtil.filterCMDsByRights(this.aclService.acls, this.templateMetaData[templateID], Consts.AccessRight.Read).forEach((cmd) => {
                // don't filter monies
                if (cmd.dataTypeID != Consts.CharDataTypeIDs.CharDataTypes.money &&
                    (cmd.charValueSetID || cmd.dataTypeID == Consts.CharDataTypeIDs.CharDataTypes.date)) {

                    let solrLabel = Utils.CharUtil.GetCharSolrLabelByCmd(cmd);
                    if (solrLabels.indexOf(solrLabel) == -1) {
                        solrLabels.push(solrLabel);
                    }
                }
            });
        });

        return solrLabels;
    }
    private clearRights(groupName?: string) {

        let groupId = this.getGroupID(groupName);
        switch (this.groupByMethod) {
            case "templategroupid":
                this.rights = this.rights.filter(x => x.document.templateGroupID !== groupId);
                break;
            case "templateid":
                this.rights = this.rights.filter(x => x.document.templateID !== groupId);
                break;
            case "statusid":
                this.rights = this.rights.filter(x => x.document.statusID !== groupId);
                break;
            default:
                this.rights = [];
                break;
        }
    }

    GetRights(groupName?: string, filters?: _.Dictionary<string[]>, refreshPreviewId?: string, newGroupsOnly: boolean = false) {
        this.clearRights(groupName);
        if (this.charTypeID == Consts.CharTypeIDs.transaction) {
            return this.getContractRights(groupName, filters, refreshPreviewId, newGroupsOnly);
        } else if (this.charTypeID == Consts.CharTypeIDs.property) {
            return this.getCatalogRights(groupName, filters, refreshPreviewId, newGroupsOnly);
        }
    }

    private getGroupedRights(groupByMethod: string, rights: (Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair)[]): _.Dictionary<(Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair)[]> {
        switch (groupByMethod) {
            case "chartypeid": {
                return { "All Rights": rights };
            }
            case "templategroupid": {
                return _.groupBy(rights, (rs) => {
                    return this.templateMetaData[rs.document.templateID].template.templateGroup;
                });

            }
            case "templateid": {
                return _.groupBy(rights, (rs) => {
                    return rs.document.template;
                });
            }
            case "statusid": {
                return _.groupBy(rights, (rs) => {
                    return rs.document.status ? rs.document.status : "None";
                });
            }
            default: {
                throw new Error("unsupported groupByMethod");
            }
        }
    }

    private hasFilters(groupName: string): boolean {
        if (!groupName) { return true; }

        for (var tagLabel in this.selectedFilters[groupName]) {
            for (var val in this.selectedFilters[groupName][tagLabel]) {
                if (!this.selectedFilters[groupName][tagLabel][val]) {
                    return true;
                }
            }
        }

        return false;
    }

    public applyFilters(event: IOnApplyFiltersEvent) {
        this.selectedFilters[event.groupName][event.tagLabel] = event.selectedFilters;
        this.GetRights(event.groupName, this.getFilters(event.groupName));
    }

    private setupRows(groupName?: string) {
        let groupedRights = this.getGroupedRights(this.groupByMethod, this.rights);

        if (groupName) {
            // do not delete grouping if filtered out by keywords or dimensions
            if ((groupedRights[groupName] && groupedRights[groupName].length > 0) || this.titleKeywords[groupName] ||
                Object.keys(this.selectedPaths).some((key) => { return this.selectedPaths[key].length > 0; }) ||
                this.hasFilters(groupName)) {
                this.groupedRows[groupName] = [];
            } else { delete this.groupedRows[groupName]; }
        } else {
            this.groupedRows = {};
        }

        _.forOwn(groupedRights, (rights, key) => {
            if (rights.length === 0 && this.groupedRows[key]) {
                this.groupedRows[key] = [];
                return;
            } else if (rights.length === 0) {
                return;
            }

            let customCols: Models.ICustomUserColumns;
            if (this.customColumns && this.customColumns[key]) {
                customCols = this.customColumns[key];
            } else {
                customCols = this.customViewsService.GetDefaultColumns(Consts.CharTypeIDs.right);
            }

            this.groupedRows[key] = this.listService.GetRows(rights.map((r) => {
                return r.document;
            }), customCols.columns, this.availableColumns, {}, {});

            this.groupedRows[key].forEach(row => {
                row.columns.filter(x => x.dataTypeID === Consts.CharDataTypeIDs.CharDataTypes.date).forEach(date => {
                    var parsed = moment.utc(date.value).format("L");

                    if (parsed === "09/09/1900" || parsed === "09/09/9999") {
                        date.value = parsed === "09/09/1900" ? "TBD" : "Perpetuity";
                        date.dataTypeID = Consts.CharDataTypeIDs.CharDataTypes.alphanumeric;
                        date.formatter = undefined;
                    }
                });
            });
        });
    }

    private getPaging(groupName?: string): { page?: number, pageCount?: number, rowCount?: number, numFound?: number, sortDir?: number, sortField?: string } {
        if (groupName) {
            this.groupPages[groupName] = this.groupPages[groupName] || {};
            this.groupPages[groupName].page = this.groupPages[groupName].page || PAGE_DEFAULT;
            this.groupPages[groupName].rowCount = this.groupPages[groupName].rowCount || ROWCOUNT_DEFAULT;
            this.groupPages[groupName].sortField = this.groupPages[groupName].sortField || this.SORTFIELD_DEFAULT;
            this.groupPages[groupName].sortDir = this.groupPages[groupName].sortDir || SORTDIR_DEFAULT;

            return this.groupPages[groupName];
        } else {
            return {
                page: PAGE_DEFAULT,
                rowCount: ROWCOUNT_DEFAULT,
                sortField: this.SORTFIELD_DEFAULT,
                sortDir: SORTDIR_DEFAULT
            };
        }
    }

    private loadCharacteristicList(charTypeID: number) {
        let deferred = this.$q.defer();
        this.entityConfigService.getCharacteristicList(charTypeID)
            .then((res) => {
                var columns = _.sortBy(res, (chr) => {
                    return chr.label;
                }).map((chr): Models.IListTableColumn => {
                    return {
                        solrLabel: Utils.CharUtil.GetCharSolrLabel(chr.dataTypeID, chr.multipleIndicator, chr.tagLabel),
                        label: chr.label,
                        characteristicID: chr.characteristicID,
                        formatter: Utils.CharUtil.GetFormatter(chr.dataTypeID),
                        dataTypeID: chr.dataTypeID,
                        systemIndicatorID: chr.systemIndicator,
                        multipleIndicator: chr.multipleIndicator
                    };
                });

                this.availableColumns = columns;
                deferred.resolve();
            });

        return deferred.promise;
    }

    private getGroupName(groupMethod: string, groupID: string) {
        switch (groupMethod) {
            case "chartypeid": {
                return "All Rights";
            }
            case "templategroupid": {
                let name: string;

                _.forOwn(this.templateMetaData, (metaData, templateID) => {
                    if (metaData.template.templateGroupID == parseInt(groupID)) {
                        name = metaData.template.templateGroup;
                    }
                });
                return name;
            }
            case "templateid": {
                let name: string;
                _.forOwn(this.templateMetaData, (metaData, templateID) => {
                    if (metaData.templateID == parseInt(groupID)) {
                        name = metaData.template.templateName;
                    }
                });
                return name;
            }
            case "statusid": {
                let name: string;
                this.rights.forEach((right) => {
                    if (right.document.statusID == parseInt(groupID)) {
                        name = right.document.status;
                    }
                });
                return name ? name : "None";
            }
            default: {
                throw new Error("unsupported groupMethod");
            }
        }
    }

    private getGroupID(groupName: string): number {
        switch (this.groupByMethod) {
            case "chartypeid": {
                return undefined;
            }
            case "templategroupid": {
                return !_.isEmpty(this.groupedRows[groupName]) ? this.groupedRows[groupName][0].templateGroupID : undefined;
            }
            case "templateid": {
                return !_.isEmpty(this.groupedRows[groupName]) ? this.groupedRows[groupName][0].templateID : undefined;
            }
            case "statusid": {
                let groupID = !_.isEmpty(this.groupedRows[groupName]) ? this.groupedRows[groupName][0].statusID : undefined;
                return groupID != 0 ? groupID : undefined;
            }
            default: {
                throw new Error("unsupported groupMethod");
            }
        }
    }

    private getContractRights(groupName?: string, filters?: _.Dictionary<string[]>, refreshPreviewId?: string, newGroupsOnly: boolean = false) {
        this.isLoading = true;
        let deferred = this.$q.defer();
        this.notifyService.startProgress();

        let parentRecID = Utils.IdBuilder.splitEntityID(this.parentEntityId).recID;
        let groupID = this.getGroupID(groupName);

        let paging = this.getPaging(groupName);
        let keywords = groupName ? this.titleKeywords[groupName] : undefined;

        let startDate = groupName && this.dateRanges[groupName] ? this.dateRanges[groupName].startDate : undefined;
        let endDate = groupName && this.dateRanges[groupName] ? this.dateRanges[groupName].endDate : undefined;

        var rightSetRecordSequence: { [recordID: number]: string } = {};

        var contractRightsPromise = this.contractService.getContractRights(
            parentRecID,
            startDate,
            endDate,
            keywords,
            filters,
            undefined,
            paging.page,
            paging.rowCount,
            paging.sortDir,
            paging.sortField,
            this.groupByMethod,
            groupID,
            this.selectedPaths)
            .then((result) => {

                if (this.rights.length > 0) {
                    _.forEach(result.templateMetaData, tmd => {
                        let metaData = this.templateMetaData[tmd.templateID];
                        if (metaData == undefined) {
                            this.templateMetaData[tmd.templateID] = tmd;
                        }
                    });
                }
                else {
                    this.templateMetaData = result.templateMetaData;
                }
                for (var groupID in result.groupedRightSets) {
                    let group = result.groupedRightSets[groupID];

                    if (!this.hadRights && group.rightSets.length > 0) { this.hadRights = true; }

                    // guarantees uniqueness amongst the rights
                    this.rights = group.rightSets.reduce((rights, next) => {
                        let found = rights.find(x => _.isEqual(x.document.recordID, next.document.recordID));
                        if (!found) {
                            rights.push(next);
                        }
                        return rights;
                    }, this.rights);

                    _.forEach(group.rightSets, r => {
                        this.rightSetRecordSequence[r.document.recordID] = r.relationship.sequenceNumber
                    });

                    let groupName = this.getGroupName(this.groupByMethod, groupID);

                    if (newGroupsOnly && this.groupedRows[groupName]) {
                        continue;
                    }

                    this.groupPages[groupName] = this.groupPages[groupName] || {};
                    this.groupPages[groupName].page = this.groupPages[groupName].page || PAGE_DEFAULT;
                    this.groupPages[groupName].rowCount = this.groupPages[groupName].rowCount || ROWCOUNT_DEFAULT;
                    this.groupPages[groupName].sortField = this.groupPages[groupName].sortField || this.SORTFIELD_DEFAULT;
                    this.groupPages[groupName].sortDir = this.groupPages[groupName].sortDir || SORTDIR_DEFAULT;

                    this.groupPages[groupName].numFound = group.numFound;
                    this.groupPages[groupName].pageCount =
                        Math.ceil(group.numFound / this.groupPages[groupName].rowCount) || 1;

                }

                this.rights.forEach((r) => {
                    this.rightsRelationshipIDs[r.document.entityID] = Utils.IdBuilder.buildRelationshipID(r.relationship);
                });

                this.setupRows(groupName);
                _.forEach(this.rights, (rs: Models.IPropertyRightsetDocumentRelationshipPair) => {
                    if (rs.relationship && rs.relationship.parentRecID) {
                        this.rightTransactions[rs.document.entityID] = {
                            recID: rs.relationship.parentRecID,
                            divID: rs.relationship.divisionID,
                            charTypeID: rs.relationship.parentCharTypeID
                        };
                    }
                });

                this.loadUsageTemplates(this.rights);

                if (_.any(this.newRightsIDs)) {
                    this.rights.forEach((right) => {
                        if (this.newRightsIDs.indexOf(right.document.entityID) > -1) {
                            this.selectRight(right.document.entityID);
                        }
                    });

                    this.newRightsIDs = [];
                }

                this.resetSelectedRights();
            });

        var contractCatalogItemsPromise: ng.IPromise<any>;
        var getImplicitCatalogItems: boolean = true;
        contractCatalogItemsPromise = this.contractService.getContractAssetTitles(parentRecID, getImplicitCatalogItems)
            .then((contractAssetsResult) => {
                this.catalogTitleDictionary = contractAssetsResult.data;
            });

        var rightsContactRecIDs: number[] = [];

        this.$q.all([contractRightsPromise, contractCatalogItemsPromise])
            .then(() => {
                _.forEach(this.rights, (rightset: Models.IContractRightDocumentRelationshipPair) => {
                    if (refreshPreviewId != undefined) {
                        if (rightset.document.entityID == refreshPreviewId) {
                            this.entityService.getEntity(rightset.document.entityID)
                                .then((res) => {
                                    let newEntityRelationshipPair = <Models.INestedRelationshipPair>res;
                                    newEntityRelationshipPair.relationship = rightset.relationship;
                                    newEntityRelationshipPair.assetRels = (<any>rightset).assetRels;
                                    newEntityRelationshipPair.contactRels = (<any>rightset).contactRels;
                                    this.$rootScope.$broadcast(Consts.Events.RefreshPreviewEntity, newEntityRelationshipPair);
                                });
                        }
                    }

                    var rightsAssetRels = rightset.assetRels;
                    var rightAssetTitles: Models.IKeyValuePair<number, string>[] = [];
                    _.forEach(rightsAssetRels, rightAssetRel => {
                        if (this.catalogTitleDictionary[rightAssetRel.childRecID]) {
                            var rightSetAssetTitlePair: Models.IKeyValuePair<number, string> = {
                                key: rightAssetRel.childRecID,
                                value: this.catalogTitleDictionary[rightAssetRel.childRecID]
                            };
                            rightAssetTitles.push(rightSetAssetTitlePair);
                            this.showRightSetCatalogItemsTD = true;
                        }
                    });

                    this.rightSetCatalogTitlesDictionary[rightset.document.entityID] = rightAssetTitles;
                    rightsContactRecIDs = rightsContactRecIDs.concat(rightset.contactRels.map(c => c.childRecID));
                });
            }).finally(() => {
                // TODO: Probably move this and make sure it doesn't happen every search
                this.isLoading = false;
                var loadHierarchyMetaDataPromise = this.loadHierarchyMetaData();
                var getContactTitlesPromise = this.getContactTitles(_.unique(rightsContactRecIDs));
                let getDealsPromise = this.getDeals([parentRecID]);
                this.associateSpecialCatalogColumns(this);
                this.usageCounts = {};
                var setRightsUsagesCountPromise = this.getRightsUsages();

                this.$q.all([loadHierarchyMetaDataPromise, getContactTitlesPromise, getDealsPromise, setRightsUsagesCountPromise])
                    .then(() => {
                        _.forEach(this.rights, (rightset: Models.IContractRightDocumentRelationshipPair) => {
                            var rightsContactRels = rightset.contactRels;
                            var rightContactTitles: Models.IKeyValuePair<number, string>[] = [];
                            _.forEach(rightsContactRels, rightsContactRel => {
                                if (this.contactTitlesDictionary[rightsContactRel.childRecID]) {
                                    var rightSetContactTitlePair: Models.IKeyValuePair<number, string> = {
                                        key: rightsContactRel.childRecID,
                                        value: this.contactTitlesDictionary[rightsContactRel.childRecID]
                                    };
                                    rightContactTitles.push(rightSetContactTitlePair);
                                    this.showRightSetContactsTD = true;
                                }
                            });
                            this.rightSetContactTitlesDictionary[rightset.document.entityID] = rightContactTitles;
                        });

                        this.notifyService.endProgress();
                        deferred.resolve();
                    });
            });

        return deferred.promise;
    }

    private getRightsUsages(): ng.IPromise<any> {
        var deferred = this.$q.defer();

        var rightRelIds = this.rights.map(right => right.relationship.relRecID);

        if (rightRelIds.length > 0) {
            this.searchService.getChildCounts(Consts.CharTypeIDs.relationship, rightRelIds, Consts.CharTypeIDs.usage)
                .then((result) => {
                    var rightsetRelUsagesCount = result.data;
                    this.usageCounts = {};
                    if (rightsetRelUsagesCount != undefined) {
                        _.forEach(this.rights, (right) => {
                            if (rightsetRelUsagesCount[right.relationship.relRecID] != undefined) {
                                var childCount = rightsetRelUsagesCount[right.relationship.relRecID];
                                this.usageCounts[right.document.entityID] = childCount;
                            }
                        });
                    }
                    deferred.resolve();
                });
        }
        else {
            deferred.resolve();
        }
        return deferred.promise;
    }

    // this shouldn't be different enough from deal rights above to warrant an entirely new method... I hope
    private getCatalogRights(groupName?: string, filters?: _.Dictionary<string[]>, refreshPreviewId?: string, newGroupsOnly: boolean = false) {
        let deferred = this.$q.defer();
        this.notifyService.startProgress();
        var parentRecID = Utils.IdBuilder.splitEntityID(this.parentEntityId).recID;

        let groupID = this.getGroupID(groupName);

        let paging = this.getPaging(groupName);
        let keywords = groupName ? this.titleKeywords[groupName] : undefined;

        let startDate = groupName && this.dateRanges[groupName] ? this.dateRanges[groupName].startDate : undefined;
        let endDate = groupName && this.dateRanges[groupName] ? this.dateRanges[groupName].endDate : undefined;

        var catalogRightsPromise = this.entityService.searchCatalogRights(
            parentRecID,
            startDate,
            endDate,
            keywords,
            filters,
            undefined,      //facetFields
            paging.page,
            paging.rowCount,
            paging.sortDir,
            paging.sortField,
            this.groupByMethod,
            groupID,
            this.selectedPaths)
            .then((result) => {
                if (this.rights.length > 0) {
                    _.forEach(result.templateMetaData, tmd => {
                        let metaData = this.templateMetaData[tmd.templateID];
                        if (metaData == undefined) {
                            this.templateMetaData[tmd.templateID] = tmd;
                        }
                    });
                }
                else {
                    this.templateMetaData = result.templateMetaData;
                }

                for (var groupID in result.groupedRightSets) {
                    let group = result.groupedRightSets[groupID];
                    if (!this.hadRights && group.rightSets.length > 0) { this.hadRights = true; }

                    this.rights = group.rightSets.reduce((rights, next) => {
                        let found = rights.find(x => _.isEqual(x.document.recordID, next.document.recordID));
                        if (!found) {
                            rights.push(next);
                        }
                        return rights;
                    }, this.rights);
                    let groupName = this.getGroupName(this.groupByMethod, groupID);

                    if (newGroupsOnly && this.groupedRows[groupName]) {
                        continue;
                    }

                    this.groupPages[groupName] = this.groupPages[groupName] || {};
                    this.groupPages[groupName].page = this.groupPages[groupName].page || PAGE_DEFAULT;
                    this.groupPages[groupName].rowCount = this.groupPages[groupName].rowCount || ROWCOUNT_DEFAULT;
                    this.groupPages[groupName].sortField = this.groupPages[groupName].sortField || this.SORTFIELD_DEFAULT;
                    this.groupPages[groupName].sortDir = this.groupPages[groupName].sortDir || SORTDIR_DEFAULT;

                    this.groupPages[groupName].numFound = group.numFound;
                    this.groupPages[groupName].pageCount =
                        Math.ceil(group.numFound / this.groupPages[groupName].rowCount) || 1;

                }

                _.forEach(this.rights, (rs: Models.IPropertyRightsetDocumentRelationshipPair) => {
                    // Check to make sure that the transactionId is a string
                    if (_.isString(rs.transactionID)) {
                        var relatedTransaction = Utils.IdBuilder.splitEntityID(rs.transactionID);
                        this.rightTransactions[rs.document.entityID] = relatedTransaction;
                        this.rightsDealIds.push(relatedTransaction.recID);
                        // below can probably go
                        rs.transactionID = relatedTransaction;
                    }
                    if (_.isString(rs.propertyID)) {
                        var relatedCatalog = IdBuilder.splitEntityID(rs.propertyID);
                        this.rightProperties[rs.document.entityID] = relatedCatalog;
                    }
                });

                this.setupRows(groupName);

                if (_.any(this.newRightsIDs)) {
                    _.forOwn(this.groupedRows, (rights, groupName) => {
                        rights.forEach((right) => {
                            if (this.newRightsIDs.indexOf(right.entityID) > -1) {
                                let document = _.find(this.rights, (r) => { return r.document.entityID == right.entityID; }).document
                                this.selectRight(document.entityID);
                            }
                        });
                    });

                    this.newRightsIDs = [];
                }
            });

        var rightsContactRecIDs: number[] = [];

        this.$q.all([catalogRightsPromise])
            .then(() => {
                _.forEach(this.rights, (rightset: Models.IContractRightDocumentRelationshipPair) => {
                    if (refreshPreviewId != undefined) {
                        if (rightset.document.entityID == refreshPreviewId) {
                            this.entityService.getEntity(rightset.document.entityID)
                                .then((res) => {
                                    let newEntityRelationshipPair = <Models.INestedRelationshipPair>res;
                                    newEntityRelationshipPair.relationship = rightset.relationship;
                                    newEntityRelationshipPair.assetRels = (<any>rightset).assetRels;
                                    newEntityRelationshipPair.contactRels = (<any>rightset).contactRels;
                                    this.$rootScope.$broadcast(Consts.Events.RefreshPreviewEntity, newEntityRelationshipPair);
                                });
                        }
                    }
                    if (rightset.contactRels != null) {
                        rightsContactRecIDs = rightsContactRecIDs.concat(rightset.contactRels.map(c => c.childRecID));
                    }
                });
            }).finally(() => {
                var loadHierarchyMetaDataPromise = this.loadHierarchyMetaData();
                var getContactTitlesPromise = this.getContactTitles(_.unique(rightsContactRecIDs));
                var getDealsPromise = this.getDeals(_.unique(this.rightsDealIds));
                this.associateSpecialCatalogColumns(this);
                this.usageCounts = {};
                var setRightsUsagesCountPromise = this.getRightsUsages();

                this.$q.all([loadHierarchyMetaDataPromise, getContactTitlesPromise, getDealsPromise, setRightsUsagesCountPromise])
                    .then(() => {
                        _.forEach(this.rights, (rightset: Models.IContractRightDocumentRelationshipPair) => {
                            var rightsContactRels = rightset.contactRels;
                            var rightContactTitles: Models.IKeyValuePair<number, string>[] = [];
                            _.forEach(rightsContactRels, rightsContactRel => {
                                if (this.contactTitlesDictionary[rightsContactRel.childRecID]) {
                                    var rightSetContactTitlePair: Models.IKeyValuePair<number, string> = {
                                        key: rightsContactRel.childRecID,
                                        value: this.contactTitlesDictionary[rightsContactRel.childRecID]
                                    };
                                    rightContactTitles.push(rightSetContactTitlePair);
                                    this.showRightSetContactsTD = true;
                                }
                            });
                            this.rightSetContactTitlesDictionary[rightset.document.entityID] = rightContactTitles;
                        });

                        this.notifyService.endProgress();
                        deferred.resolve();
                    });
            });

        return deferred.promise;
    }

    DeselectRight(groupName: string, right: Models.IListTableRow) {
        _.remove(this.selectedRights[groupName], (r) => {
            return r.entityID == right.entityID;
        });
    }

    private selectRight(entityId: string) {
        let rightGrouping = this.findRightGrouping(entityId);
        if (rightGrouping) {
            this.selectedRights[rightGrouping.groupName] = this.selectedRights[rightGrouping.groupName] || [];
            this.selectedRights[rightGrouping.groupName].push(rightGrouping.right);
        }
    }

    private findRightGrouping(entityId: string) {
        for (let groupName in this.groupedRows) {

            let rows = this.groupedRows[groupName];
            let foundRight = rows.find(x => x.entityID == entityId);

            if (foundRight) {
                let result: IRightGrouping = {
                    right: foundRight,
                    groupName: groupName
                };
                return result;
            }
        }

        return null;
    }

    private resetSelectedRights(templateNames?: string[]) {
        templateNames = templateNames || [];
        if (templateNames.length == 0) {
            _.forOwn(this.groupedRows, (rows, templateName) => {
                templateNames.push(templateName);
            });
        }

        _.forEach(templateNames, (templateName) => {

            if (this.selectedRights[templateName] && this.selectedRights[templateName].length > 0) {
                var selectedRightsIDs = this.selectedRights[templateName].map((r) => { return r.entityID; });
                this.selectedRights[templateName] = [];

                selectedRightsIDs.forEach((id) => {
                    if (_.any(this.groupedRows[templateName], (r) => r.entityID == id)) {
                        this.selectedRights[templateName].push(_.find(this.groupedRows[templateName], (r) => r.entityID == id));
                    }
                });
            }
        });
    }

    private loadHierarchyMetaData(): ng.IPromise<any> {
        var deferred = this.$q.defer();

        let promises: ng.IPromise<any>[] = [];

        this.entityConfigService.getRightsDimensions()
            .then((rightsLovs) => {
                // for each group
                _.forOwn(this.groupedRows, (rows, groupName) => {
                    if (this.bulkEditHierarchyEditCmds[groupName] && this.bulkEditHierarchyEditCmds[groupName].length > 0) {
                        return;
                    }
                    let cmds: Models.ICharacteristicMetaData[] = [];
                    let templateIDs = _.uniq(rows.map((row => { return row.templateID; })));

                    this.bulkEditHierarchyEditCmds[groupName] = [];
                    this.lovMetaDatas[groupName] = {};
                    // for each template in this group
                    _.forEach(templateIDs, (templateID) => {
                        let metaData = this.templateMetaData[templateID.toString()];

                        // for each characteristic with a charValueSourceID and charValueSetID
                        metaData.characteristicMetaDatas
                            .filter((cmd) => !_.isEmpty(cmd.charValueSourceID) && !_.isEmpty(cmd.charValueSetID))
                            .forEach((cmd) => {
                                // add new CMD's (these could have been added already from other templates)
                                if (!_.any(this.lovCMDs, (lcmd) => lcmd.characteristicID == cmd.characteristicID)) {
                                    const sysInd = cmd.systemIndicator;
                                    if (rightsLovs.characteristics[sysInd] != null) {
                                        const chr = rightsLovs.characteristics[sysInd];
                                        // fake a CMD from a characteristic + charValueSourceID
                                        this.lovCMDs.push({
                                            ...chr,
                                            groupID: null,
                                            sequenceNumber: cmd.sequenceNumber,
                                            requiredIndicator: null,
                                            charValueSourceID: rightsLovs.lovs[sysInd].charValueSourceID,
                                            acl: "",
                                            triggerTypeID: null,
                                            triggerValue: null
                                        });
                                    } else {
                                        this.lovCMDs.push(cmd);
                                    }
                                }

                                if (!_.any(cmds, (lcmd) => lcmd.characteristicID == cmd.characteristicID)) {
                                    cmds.push(cmd);
                                }
                            });
                    });

                    // for each of thise templates cmds with a hierarchy
                    cmds.forEach((cmd) => {
                        // load the lov data for each cmd
                        let promise = this.entityService.getCharLovMetaData(cmd.charValueSourceID, cmd.charValueSetID)
                            .then((result2) => {
                                this.lovMetaDatas[groupName][cmd.charValueSourceID] = result2;

                                // if this lov is a hierarchy add it to the bulk hierarchy cmd list
                                if (_.any(result2.listOfValues, (lov) => { return lov.childValues.length > 0; })) {
                                    this.bulkEditHierarchyEditCmds[groupName].push(cmd);
                                }
                            });
                        promises.push(promise);
                    });
                });
            });


        this.$q.all(promises).then(() => deferred.resolve());

        return deferred.promise;
    }

    private loadUsageTemplates(rightSets: (Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair)[]) {
        const templateIDs = rightSets.map(x => { return x.document.templateID; });
        const uniqTemplateIDs = _.uniq(templateIDs);

        if (uniqTemplateIDs.length > 0) {
            uniqTemplateIDs.forEach((templateID) => {
                if (!this.usageTemplates[templateID.toString()]) {
                    this.notifyService.startProgress();
                    this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.right, templateID, Consts.CharTypeIDs.usage)
                        .then((res) => {
                            this.usageTemplates[templateID.toString()] = _.filter(res, ((t) => { return t.templateGroupID == Consts.TemplateGroupIDs.UsageModuleLevel; }));
                        })
                        .finally(() => {
                            var allUsageDefaultsTemplateIDs: number[] = [];
                            _.forEach(this.allUsageTemplateDefaults, (u) => {
                                allUsageDefaultsTemplateIDs = allUsageDefaultsTemplateIDs.concat(u.templateIDs);
                            });

                            var rightSetUsageTemplateIDs = this.usageTemplates[templateID.toString()].map(t => t.templateID);
                            var rightSetDefaultUsageTemplateIDs = rightSetUsageTemplateIDs.filter(x => allUsageDefaultsTemplateIDs.indexOf(x) != -1);
                            var usageTemplateDataDefaultSets: Models.IDataDefaultSet[] = [];

                            _.forEach(this.allUsageTemplateDefaults, (a) => {
                                var usageTemplateDefaultTemplateIDs = a.templateIDs;
                                var hasMatch = a.templateIDs.some(a => rightSetDefaultUsageTemplateIDs.some(r => a === r));
                                if (hasMatch) {
                                    usageTemplateDataDefaultSets.push(a);
                                }
                            });

                            this.usageTemplateDataDefaultSets[templateID.toString()] = usageTemplateDataDefaultSets;

                            this.notifyService.endProgress();
                        });
                }
            });
        }
    }

    CopySuccessful(newEntityID: string) {
        this.forceRefresh = true;
    }

	/*
	 * Remove a RightSet
	 * @params rightSet the rightset to be removed
	 */
    RemoveRight(rightSet: Models.IListTableRow) {
        if (this.$window.confirm("Are you sure you want to delete these Rights?")) {
            let right = _.find(this.rights, (r) => { return r.document.entityID == rightSet.entityID; });
            let relationship = right.relationship;
            let relID = Utils.IdBuilder.buildEntityID(relationship.divisionID, Consts.CharTypeIDs.relationship, relationship.relRecID);

            this.notifyService.startProgress();
            this.entityService.deleteEntity(right.document.entityID)
                .then((result) => {
                    _.forOwn(this.selectedRights, (rights, groupName) => {
                        _.remove(rights, (r) => r.recordID == right.document.recordID);
                    });
                    if (this.onDataChanged) {
                        this.onDataChanged({ parentEntityID: this.parentEntityId });
                    }
                    this.modalService.jobProgress(result.jobID, "Deleting Record", null, false, false, false).then(jobProgressResult => {
                        if (jobProgressResult.status == "Done") {
                            this.GetRights(right.document.template, this.getFilters(right.document.template));
                        }
                    });
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    private showJob(jobID: string, jobTitle: string, jobTemplateID: number) {
        this.jobId = jobID;
        this.jobTitle = jobTitle;
        this.jobTemplateID = jobTemplateID;
        this.showJobProgressStatus = true;
    }

    private Init(): ng.IPromise<any> {
        let deferred = this.$q.defer();
        let promises: ng.IPromise<any>[] = [];
        let split = Utils.IdBuilder.splitEntityID(this.parentEntityId);
        let entity: Models.IEntityCharDataPair;
        promises.push(this.entityService.getEntity(this.parentEntityId)
            .then((res) => {
                entity = res;
            }));

        promises.push(this.loadCharacteristicList(Consts.CharTypeIDs.right));

        this.$q.all(promises).then(() => {
            let promises: ng.IPromise<any>[] = [];
            promises.push(this.entityService.getAssociatedTemplatesDefaults(split.charTypeID, entity.record.templateID, Consts.CharTypeIDs.right)
                .then((res) => {
                    this.rightsDefaults = res.dataDefaultSets;
                }));

            let childTemplates: Models.ICharacteristicTemplate[];
            promises.push(this.entityService.getAssociatedTemplatesForTemplate(split.charTypeID, entity.record.templateID, Consts.CharTypeIDs.right)
                .then((res) => {
                    childTemplates = res;
                }));

            promises.push(this.entityService.getAssociatedTemplatesDefaults(Consts.CharTypeIDs.relationship, entity.record.templateID, Consts.CharTypeIDs.usage, split.charTypeID, Consts.CharTypeIDs.right)
                .then((res) => {
                    this.allUsageTemplateDefaults = res.dataDefaultSets;
                }));

            this.$q.all(promises).then(() => {
                if (childTemplates.length > 0) { deferred.resolve(); } else { deferred.reject(); }
            });
        });

        return deferred.promise;
    }

    /* EVERYTHING BELOW SHOULD BE RIPPED OUT OF THIS DIRECTIVE AND ADDED TO MODAL SERVICE (GENERICALLY) */
    public BulkEditRights(groupName: string, $event: ng.IAngularEvent): void {
        $event.preventDefault();
        var bulkEditContractRights: { [name: string]: Models.IListTableRow[] } = {};
        bulkEditContractRights[groupName] = _.cloneDeep(this.selectedRights[groupName]);
        let entityIDs = bulkEditContractRights[groupName].map((r) => {
            return Utils.IdBuilder.splitEntityID(r.entityID);
        });
        this.openEditRightsModal(groupName, entityIDs);
    }

    public openEditRightsModal(groupName: string, entityIds: IEntityID[]) {
        let contractRightTemplateIds = this.getSelectedTemplateIds(groupName);
        if (contractRightTemplateIds.length > 1) {
            alert("Bulk Edit can only be performed on records of the same Template.");
            return this.$q.resolve();
        }

        if (this.charTypeID == Consts.CharTypeIDs.transaction) {
            if (!_.any(this.relatedChildCharTypeIDs, c => c == Consts.CharTypeIDs.property)) {
                this.relatedChildCharTypeIDs.push(Consts.CharTypeIDs.property);
            }
        }

        this.entityConfigService.getCharTypeTemplateCharTypeAssociationList(Consts.CharTypeIDs.right, contractRightTemplateIds[0])
            .then((result) => {
                if (_.any(result, c => c.childCharTypeID == Consts.CharTypeIDs.user)) {
                    if (!_.any(this.relatedChildCharTypeIDs, c => c == Consts.CharTypeIDs.user)) {
                        this.relatedChildCharTypeIDs.push(Consts.CharTypeIDs.user);
                    }
                }
            }).finally(() => {
                return this.entityService.getEntityCharDatas(entityIds[0].divID, entityIds[0].charTypeID, entityIds.map((id) => { return id.recID; }))
                    .then((res) => {
                        var groupedBulkEditEntityCharDatas: { [entityID: string]: Models.ICharDataCollection[] } = {};
                        groupedBulkEditEntityCharDatas[this.parentEntityId] = res;

                        return this.getParameters(groupName, entityIds, true).then(bulkEditParameters => {
                            return this.modalService.bulkEdit(this.parentEntityId, groupedBulkEditEntityCharDatas, this.divID, Consts.CharTypeIDs.right, bulkEditParameters.templateIds[0], this.parentCurrencyCharData,
                                bulkEditParameters.bulkEditRelationshipTitles, false, bulkEditParameters.bulkEditRightsetTrxRels, this.relatedChildCharTypeIDs, bulkEditParameters.bulkEditRightsetRels, "", 0, {}, {})
                                .then((result) => {
                                    if (!_.isEmpty(result.jobID)) {
                                        var progressStatus: string = "";
                                        this.modalService.jobProgress(result.jobID, result.jobTitle, progressStatus, false, false, false)
                                            .then((jobProgressResult) => {
                                                if (jobProgressResult.status == "Done") {
                                                    for (var groupName in this.groupedRows) {
                                                        this.GetRights(groupName, this.getFilters(groupName));
                                                    }
                                                }
                                            });
                                    }
                                });
                        });
                    });
            });
    }

    private getParameters(groupName: string, entityIds: IEntityID[], getImplicitCatalogItems: boolean = false): ng.IPromise<BulkEditParameters> {
        if (!_.any(entityIds)) {
            return this.$q.resolve(this.getParametersFromSelectedRights(this.selectedRights[groupName]))
        }

        return this.getRights(groupName).then(rights => {
            var allRightsets = this.getGroupedRights(this.groupByMethod, rights);

            let promises = {
                rightSetCatalogTitlesDictionary: this.rightService.getRightSetCatalogTitlesDictionary(allRightsets[groupName], this.parentRecID, getImplicitCatalogItems),
                rightSetContactTitlesDictionary: this.rightService.getRightSetContactTitlesDictionary(allRightsets[groupName])
            }
            return this.$q.all(promises).then(results => {
                return this.getParametersFromEntities(entityIds, allRightsets[groupName], results.rightSetCatalogTitlesDictionary, results.rightSetContactTitlesDictionary);
            });
        })
    }

    private getRights(groupName: string): ng.IPromise<(Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair)[]> {
        const groupId = this.getGroupID(groupName);
        let paging = this.getPaging(groupName);
        let keywords = groupName ? this.titleKeywords[groupName] : undefined;
        let startDate = groupName && this.dateRanges[groupName] ? this.dateRanges[groupName].startDate : undefined;
        let endDate = groupName && this.dateRanges[groupName] ? this.dateRanges[groupName].endDate : undefined;

        return this.rightService.searchRights(this.parentEntityId, this.groupByMethod, groupId, paging.numFound, startDate, endDate, keywords, this.getFilters(groupName), undefined,
            paging.sortDir, paging.sortField, this.selectedPaths)
            .then(results => {
                const groupedRightsets = results.groupedRightSets;
                if (this.groupByMethod === "chartypeid") {
                    return groupedRightsets[Consts.CharTypeIDs.right].rightSets;
                } else {
                    return groupedRightsets[groupId].rightSets;
                }
            });
    }

    private getParametersFromEntities(entityIds: IEntityID[], allRightSets: (Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair)[], rightSetCatalogTitlesDictionary: any, rightSetContactTitlesDictionary: any): BulkEditParameters {
        let bulkEditRelationshipTitles: { [entityID: string]: { [charTypeID: number]: Models.IEntityRecIDTitle[] }; } = {};
        let bulkEditRightsetRels: { [rightSetEntityID: string]: Models.IEntityRelationship[] } = {};
        let bulkEditRightsetTrxRels: Models.IEntityRelationship[] = [];
        let templateIds: number[] = [];

        let entityIdStrings = entityIds.map(entity => {
            let entityId: string = IdBuilder.buildEntityID(entity.divID, entity.charTypeID, entity.recID);
            return entityId;
        });

        _.forEach(entityIdStrings, (entityId) => {
            let r2 = _.find(allRightSets, (right) => {
                return right.document.entityID == entityId;
            });
            var allRightRels: any = [];
            bulkEditRelationshipTitles[entityId] = {};
            if (_.any(this.relatedChildCharTypeIDs, c => c == Consts.CharTypeIDs.property)) {
                var rightSetCatalogItems = rightSetCatalogTitlesDictionary[entityId];
                var rightCatalogRels = (<any>r2).assetRels;
                allRightRels = allRightRels.concat(rightCatalogRels);
                var rightCatalogItems: Models.IEntityRecIDTitle[] = [];
                _.forEach(rightSetCatalogItems, (rci) => {
                    var rightCatalogItem: Models.IEntityRecIDTitle = {
                        recID: rci.key,
                        title: rci.value
                    };
                    rightCatalogItems.push(rightCatalogItem);
                });
                bulkEditRelationshipTitles[entityId][Consts.CharTypeIDs.property] = rightCatalogItems;
            }
            if (_.any(this.relatedChildCharTypeIDs, c => c == Consts.CharTypeIDs.user)) {
                var rightSetContacts = rightSetContactTitlesDictionary[entityId];
                var rightContactRels = (<any>r2).contactRels;
                allRightRels = allRightRels.concat(rightContactRels);
                var rightContacts: Models.IEntityRecIDTitle[] = [];
                _.forEach(rightSetContacts, (rc) => {
                    var rightContact: Models.IEntityRecIDTitle = {
                        recID: rc.key,
                        title: rc.value
                    };
                    rightContacts.push(rightContact);
                });
                bulkEditRelationshipTitles[entityId][Consts.CharTypeIDs.user] = rightContacts;
            }
            let right = _.find(allRightSets, (right) => {
                return right.document.entityID == entityId;
            });
            bulkEditRightsetRels[entityId] = allRightRels;
            bulkEditRightsetTrxRels.push(right.relationship);
            templateIds.push(right.document.templateID);
        });
        return new BulkEditParameters(bulkEditRelationshipTitles, bulkEditRightsetRels, bulkEditRightsetTrxRels, templateIds);
    }

    private getParametersFromSelectedRights(selectedRights: Models.IListTableRow[]): BulkEditParameters {
        let bulkEditRelationshipTitles: { [entityID: string]: { [charTypeID: number]: Models.IEntityRecIDTitle[] }; } = {};
        let bulkEditRightsetRels: { [rightSetEntityID: string]: Models.IEntityRelationship[] } = {};
        let bulkEditRightsetTrxRels: Models.IEntityRelationship[] = []; var contractRightTemplateIDs: number[] = [];
        var contractRightTemplateIDs: number[] = [];

        _.forEach(selectedRights, (cr) => {
            if (contractRightTemplateIDs.indexOf(cr.templateID) == -1) {
                contractRightTemplateIDs.push(cr.templateID);
            }
        });

        _.forEach(selectedRights, (cr) => {
            let r2 = _.find(this.rights, (right) => {
                return right.document.entityID == cr.entityID;
            });
            var allRightRels: any = [];
            bulkEditRelationshipTitles[cr.entityID] = {};
            if (_.any(this.relatedChildCharTypeIDs, c => c == Consts.CharTypeIDs.property)) {
                var rightSetCatalogItems = this.rightSetCatalogTitlesDictionary[cr.entityID];
                var rightCatalogRels = (<any>r2).assetRels;
                allRightRels = allRightRels.concat(rightCatalogRels);
                var rightCatalogItems: Models.IEntityRecIDTitle[] = [];
                _.forEach(rightSetCatalogItems, (rci) => {
                    var rightCatalogItem: Models.IEntityRecIDTitle = {
                        recID: rci.key,
                        title: rci.value
                    };
                    rightCatalogItems.push(rightCatalogItem);
                });
                bulkEditRelationshipTitles[cr.entityID][Consts.CharTypeIDs.property] = rightCatalogItems;
            }
            if (_.any(this.relatedChildCharTypeIDs, c => c == Consts.CharTypeIDs.user)) {
                var rightSetContacts = this.rightSetContactTitlesDictionary[cr.entityID];
                var rightContactRels = (<any>r2).contactRels;
                allRightRels = allRightRels.concat(rightContactRels);
                var rightContacts: Models.IEntityRecIDTitle[] = [];
                _.forEach(rightSetContacts, (rc) => {
                    var rightContact: Models.IEntityRecIDTitle = {
                        recID: rc.key,
                        title: rc.value
                    };
                    rightContacts.push(rightContact);
                });
                bulkEditRelationshipTitles[cr.entityID][Consts.CharTypeIDs.user] = rightContacts;
            }
            let right = _.find(this.rights, (right) => {
                return right.document.entityID == cr.entityID;
            });
            bulkEditRightsetRels[cr.entityID] = allRightRels;
            bulkEditRightsetTrxRels.push(right.relationship);
        });
        return new BulkEditParameters(bulkEditRelationshipTitles, bulkEditRightsetRels, bulkEditRightsetTrxRels, contractRightTemplateIDs);
    }

    GenerateDescription(templateName: string) {
        var output = "You will ";
        if (this.bulkEditDateMode == "set") {
            output += "set ";
            if (this.bulkEditDateSetStart && this.bulkEditDateSetEnd) {
                output += "<strong>" + this.bulkEditDateStartCmd.label + "</strong> to <strong>" + moment(this.bulkEditDateSetStart).format("L") + "</strong> and <strong>" + this.bulkEditDateEndCmd.label + "</strong> to <strong>" + moment(this.bulkEditDateSetEnd).format("L") + "</strong>";
            } else if (this.bulkEditDateSetStart) {
                output += "<strong>" + this.bulkEditDateStartCmd.label + "</strong> to <strong>" + moment(this.bulkEditDateSetStart).format("L") + "</strong>";
            } else if (this.bulkEditDateSetEnd) {
                output += "<strong>" + this.bulkEditDateEndCmd.label + "</strong> to <strong>" + moment(this.bulkEditDateSetEnd).format("L") + "</strong>";
            } else {
                return "";
            }
        } else if (this.bulkEditDateMode == "adjust") {
            var adjustStart = this.bulkEditDateAdjustStart || 0;
            var adjustEnd = this.bulkEditDateAdjustEnd || 0;
            var actionWord = (num: number) => {
                if (num > 0) {
                    return " forward ";
                } else if (num < 0) {
                    return " backward ";
                }
            };
            var dayWord = (num: number) => {
                if (num == 1) {
                    return " day ";
                }
                return " days ";
            };

            output += " adjust ";

            if (adjustStart != 0 && adjustEnd != 0) {
                output += " <strong>" + this.bulkEditDateStartCmd.label + "</strong> <strong>" + actionWord(adjustStart) + "</strong> <strong>" + Math.abs(adjustStart) + dayWord(adjustStart) + "</strong>";
                output += " and ";
                output += " <strong>" + this.bulkEditDateEndCmd.label + "</strong> <strong>" + actionWord(adjustEnd) + "</strong> <strong>" + Math.abs(adjustEnd) + dayWord(adjustEnd) + "</strong>";
            } else if (adjustStart != 0 && adjustEnd == 0) {
                output += " <strong>" + this.bulkEditDateStartCmd.label + "</strong> <strong>" + actionWord(adjustStart) + "</strong> <strong>" + Math.abs(adjustStart) + dayWord(adjustStart) + "</strong>";
            } else if (adjustStart == 0 && adjustEnd != 0) {
                output += " <strong>" + this.bulkEditDateEndCmd.label + "</strong> <strong>" + actionWord(adjustEnd) + "</strong> <strong>" + Math.abs(adjustEnd) + dayWord(adjustEnd) + "</strong>";
            } else {
                return "";
            }
        } else {
            return "";
        }

        if (this.selectedRights[templateName].length == 1) {
            output += " for 1 set of Rights";
        } else {
            output += " for " + this.selectedRights[templateName].length + " Rights";
        }

        return output;
    }

    BulkEditDates(groupName: string, $event: ng.IAngularEvent) {
        $event.preventDefault();
        if (this.selectedRights[groupName].length > 0) {
            var metaData = this.templateMetaData[this.selectedRights[groupName][0].templateID];
            this.bulkEditDateStartCmd = _.find(metaData.characteristicMetaDatas, (cmd) => cmd.systemIndicator == 5);
            this.bulkEditDateEndCmd = _.find(metaData.characteristicMetaDatas, (cmd) => cmd.systemIndicator == 6);

            this.bulkEditTemplate = groupName;
            this.bulkEditDatesModalOpen = true;
        }
    }

    ExecuteEditDates(groupName: string) {
        var rightSetRecordIDs = this.selectedRights[groupName].map((right) => right.recordID);
        this.notifyService.startProgress();
        this.contractService.bulkEditDates(rightSetRecordIDs, this.bulkEditDateStartCmd.characteristicID, this.bulkEditDateEndCmd.characteristicID, this.bulkEditDateSetStart,
            this.bulkEditDateSetEnd, this.bulkEditDateAdjustStart, this.bulkEditDateAdjustEnd)
            .then((result) => {
                if (result.success) {
                    this.bulkEditDatesModalOpen = false;
                    this.modalService.jobProgress(result.jobID, "Executing Edit Dates For Rights Job", null, false, false, false).then(jobProgressResult => {
                        if (jobProgressResult.status == "Done") {
                            return this.GetRights(groupName, this.getFilters(groupName));
                        }
                    });
                } else {
                    this.notifyService.notifyError("Error editing Rights Dates: " + (result.bulkMessage || result.message));
                }
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    // TODO: Fix
    BulkEditHierarchy(groupName: string, bulkEditHierarchyCmd: Models.ICharacteristicMetaData, $event: ng.IAngularEvent) {
        $event.preventDefault();

        // If any of the selected rights in this group don't have this characteristic then show a warning
        for (var i = 0; i < this.selectedRights[groupName].length; i++) {
            let right = this.selectedRights[groupName][i];

            let template = this.templateMetaData[right.templateID.toString()];
            let cmd = _.find(template.characteristicMetaDatas, (cmd) => {
                return cmd.characteristicID == bulkEditHierarchyCmd.characteristicID;
            });

            if (cmd === undefined) {
                alert(`The selected Rights do not all have the ${bulkEditHierarchyCmd.label} characteristic.`);
                return;
            }
        }

        this.bulkEditHierarchyCmd = bulkEditHierarchyCmd;
        this.bulkEditHierarchyValueIDs = [];
        this.bulkEditTemplate = groupName;
        this.bulkEditHierarchyModalOpen = true;
    }

    RemoveBulkEditLov(lov: Models.ICharacteristicMetaDataValue, $event: ng.IAngularEvent) {
        $event.preventDefault();
        _.remove(this.bulkEditHierarchyValueIDs, (v) => v == lov.characteristicValueID);
    }

    ExecuteEditHierarchy() {
        let groupName = this.bulkEditTemplate;
        let rightsetRecordIDs = this.selectedRights[groupName].map((right) => { return right.recordID; });

        this.notifyService.startProgress();
        this.contractService.bulkEditHierarchy(this.bulkEditHierarchyMode, rightsetRecordIDs, this.bulkEditHierarchyCmd.characteristicID, this.bulkEditHierarchyValueIDs)
            .then((result) => {
                if (result.success) {
                    this.bulkEditHierarchyModalOpen = false;

                    this.modalService.jobProgress(result.jobID, "Executing Edit Hierarchy For Rights Job", null, false, false, false).then(jobProgressResult => {
                        if (jobProgressResult.status == "Done") {
                            return this.GetRights(groupName, this.getFilters(groupName));
                        }
                    });

                } else {
                    this.notifyService.notifyError("Error editing Rights values: " + (result.bulkMessage || result.message));
                }
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    BulkEditStatus(groupName: string, $event: ng.IAngularEvent) {
        $event.preventDefault();

        let templateName: string;
        let uniqueTemplates = _.uniq(this.selectedRights[groupName], (right) => {
            return right.templateID;
        });

        if (uniqueTemplates.length == 1) {
            templateName = this.templateMetaData[this.selectedRights[groupName][0].templateID].template.templateName;
        } else {
            alert("Cannot bulk edit for different templates");
            return;
        }

        this.bulkEditTemplate = groupName;
        if (this.CanEditStatus(groupName)) {

            var recordIDTitlesDictionary: { [key: number]: string } = {};
            var templateID = uniqueTemplates[0].templateID;
            var statusID = this.selectedRights[groupName][0].statusID;

            _.each(this.selectedRights[groupName], r => {
                var rightDoc = _.find(this.rights, (right) => {
                    return right.document.entityID == r.entityID;
                });
                if (rightDoc != undefined) {
                    recordIDTitlesDictionary[rightDoc.document.recordID] = rightDoc.document.title;
                }
            });

            this.modalService.bulkExecuteWorkFlow(this.parentEntityId, Consts.CharTypeIDs.right, templateID, recordIDTitlesDictionary, null, null, statusID)
                .then((result) => {
                    if (result == undefined) {
                        this.forceRefresh = true;
                    } else {
                        if (!_.isEmpty(result.jobID)) {
                            var progressStatus: string = "";
                            this.modalService.jobProgress(result.jobID, result.jobTitle, progressStatus, false, false, false)
                                .then((jobProgressResult) => {
                                    if (jobProgressResult.status == "Done") {
                                        this.forceRefresh = true;
                                    }
                                });
                        }
                    }
                });

        } else {
            this.bulkCanEditStatus = false;
            this.bulkWorkflowActions = {};
            this.bulkEditStatusModalOpen = false;
        }
    }

    CanEditStatus(groupName: string) {
        if (this.selectedRights[groupName].length > 0) {
            // check to make sure the statuses and templates match
            let firstSelectedRight = this.selectedRights[groupName][0];

            if (!_.any(this.selectedRights[groupName], r => r.statusID != firstSelectedRight.statusID || r.templateID != firstSelectedRight.templateID)) {
                return true;
            }
        }
        return false;
    }

    BulkDelete(groupName: string, $event: ng.IAngularEvent) {
        $event.preventDefault();
        this.bulkEditTemplate = groupName;
        this.bulkDeleteModalOpen = true;
    }

    ExecuteDelete(isValid: boolean) {
        if (isValid) {
            let groupName = this.bulkEditTemplate;
            let rightSetRecordIDs = this.selectedRights[groupName].map((right) => { return right.recordID; });

            this.notifyService.startProgress();
            this.contractService.bulkEditDelete(this.charTypeID, this.parentRecID, rightSetRecordIDs)
                .then((result) => {
                    if (result.success) {
                        this.modalService.jobProgress(result.jobID, "Deleting Rights Job", null, false, true, true).then(jobProgressResult => {
                            if (jobProgressResult.status == "Done") {
                                return this.GetRights(groupName, this.getFilters(groupName));
                            }
                        });

                        _.forEach(rightSetRecordIDs, (rID) => {
                            _.remove(this.selectedRights[groupName], r => r.recordID == rID);
                        });
                        this.bulkDeleteModalOpen = false;

                    } else {
                        this.notifyService.notifyError("Error deleting Rights: " + (result.bulkMessage || result.message));
                    }
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    RemoveSelectedRight(right: Models.IContractRightDocumentRelationshipPair | Models.IPropertyRightsetDocumentRelationshipPair) {
        if (this.selectedRights[right.document.template].length <= 1) {
            this.$window.alert("At least one set of Rights is required.");
            this.notifyService.broadcastDone();
        } else {
            _.remove(this.selectedRights[right.document.template], (v) => v.recordID == right.document.recordID);
        }
    }

    BulkEditAssociations(groupName: string) {
        var contractRightTemplateIDs: number[] = [];

        _.forEach(this.selectedRights[groupName], (cr) => {
            if (contractRightTemplateIDs.indexOf(cr.templateID) == -1) {
                contractRightTemplateIDs.push(cr.templateID);
            }
        });

        if (contractRightTemplateIDs.length > 1) {
            alert("Bulk Edit can only be performed on records of the same Template.");
            return;
        }
        this.bulkExistingRelationships = [];
        this.selectedRights[groupName].forEach((right) => {
            let r = _.find(this.rights, (rightRelPair) => {
                return rightRelPair.document.entityID == right.entityID;
            });
            if ((<Models.IContractRightDocumentRelationshipPair>r).assetRels) {
                this.bulkExistingRelationships = this.bulkExistingRelationships.concat((<Models.IContractRightDocumentRelationshipPair>r).assetRels);
            }
        });

        this.bulkEditTemplate = groupName;
        this.bulkEditAssociationsModalOpen = true;
        this.bulkRightsTemplateID = contractRightTemplateIDs[0];
    }

    private deleteRelationships(relationshipIDs: string[]) {
        return this.entityService.deleteEntityRelationships(relationshipIDs);
    }

    SaveBulkCatalogItems(groupName: string) {
        var confirmMessage = `Are you sure you want to ${BulkAssociationMode[this.bulkCatalogAssociationMode]} Catalog Items for ${this.selectedRights[groupName].length} Right Sets?`;

        if (this.$window.confirm(confirmMessage)) {
            var selectedCatalogItemIDs = _.map(this.bulkCatalogItems, (ci) => { return ci.recordID; });

            let deleteRelationshipIDs: string[] = [];
            let addRelationships: Models.IEntityRelationship[] = [];

            this.selectedRights[groupName].forEach((right) => {
                let foundRight = _.find(this.rights, (rightRelPair) => {
                    return rightRelPair.document.entityID == right.entityID;
                });
                var r = <Models.IContractRightDocumentRelationshipPair>foundRight;

                if (this.bulkCatalogAssociationMode == BulkAssociationMode.Remove || this.bulkCatalogAssociationMode == BulkAssociationMode.Replace) {
                    var removeEntities: Models.IEntityRelationship[];
                    if (this.bulkCatalogAssociationMode == BulkAssociationMode.Remove) {
                        removeEntities = _.filter(r.assetRels, (rel) => {
                            return selectedCatalogItemIDs.indexOf(rel.childRecID) > -1;
                        });
                    } else {
                        removeEntities = _.filter(r.assetRels, (rel) => {
                            return selectedCatalogItemIDs.indexOf(rel.childRecID) == -1;
                        });
                    }

                    if (removeEntities.length > 0) {
                        var divID = this.rights[0].document.divisionID;

                        removeEntities.forEach((rm) => {
                            deleteRelationshipIDs.push(Utils.IdBuilder.buildEntityID(divID, Consts.CharTypeIDs.relationship, rm.relRecID));
                        });
                    }
                }

                if (this.bulkCatalogAssociationMode == BulkAssociationMode.Add || this.bulkCatalogAssociationMode == BulkAssociationMode.Replace) {
                    var addedEntities = _.filter(selectedCatalogItemIDs, (ci) => {
                        return !_.any(r.assetRels, (ar) => {
                            return ar.childRecID == ci;
                        });
                    });

                    if (addedEntities.length > 0) {
                        addedEntities.forEach((recordId) => {
                            let split = Utils.IdBuilder.splitEntityID(right.entityID);
                            addRelationships.push({
                                divisionID: r.document.divisionID,
                                parentRecID: r.relationship.relRecID,
                                parentCharTypeID: Consts.CharTypeIDs.relationship,
                                childCharTypeID: Consts.CharTypeIDs.property,
                                childRecID: recordId,
                                sequenceNumber: undefined
                            });
                        });
                    }
                }
            });

            this.notifyService.startProgress();
            this.entityService.bulkUpdateRelationships(addRelationships, deleteRelationshipIDs)
                .then((res) => {
                    this.notifyService.endProgress();
                    this.GetRights(groupName, this.getFilters(groupName));
                    this.bulkEditAssociationsModalOpen = false;
                    this.bulkCatalogAssociationMode = BulkAssociationMode.Replace;
                });
        } else {
            // to re-enable the rl-busy-button
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    CanDelete(rightSet: Models.IListTableRow) {
        if (rightSet != undefined) {
            var acl = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.right, rightSet.templateGroupID, rightSet.templateID);
            if (this.canDeleteResults[acl] == null) {
                this.canDeleteResults[acl] = Utils.AclUtil.hasDeleteAccess(this.aclService.acls, acl);
            }
            return this.canDeleteResults[acl];
        }
    }

    CanEdit(rightSet: Models.IListTableRow) {
        if (rightSet != undefined) {
            var acl = Utils.AclUtil.getDataEntityAcl(Consts.CharTypeIDs.right, rightSet.templateGroupID, rightSet.templateID);
            if (this.canEditResults[acl] == null) {
                this.canEditResults[acl] = Utils.AclUtil.hasWriteAccess(this.aclService.acls, acl);
            }
            return this.canEditResults[acl];
        }
    }

    ExportCSV($event: ng.IAngularEvent, groupName: string) {
        $event.preventDefault();
        this.notifyService.startProgress();

        const groupRows = this.groupedRows[groupName];
        const columns = groupRows[0].columns;
        let templateIDs = [-1];

        if (groupName !== "All Rights") {
            templateIDs = _.map(_.uniq(groupRows, "templateID"),
                row => {
                    return row.templateID;
                });

        }

        var solrColumns: Models.IKeyValuePair<string, number>[] = [];
        columns.forEach(c => {
            solrColumns.push({ key: c.solrLabel, value: c.characteristicID });
        });

        const filters = this.getFilters(groupName);
        const sortData = this.getPaging(groupName);
        const startDate = groupName && this.dateRanges[groupName] ? this.dateRanges[groupName].startDate : undefined;
        const endDate = groupName && this.dateRanges[groupName] ? this.dateRanges[groupName].endDate : undefined;
        const keywords = groupName ? this.titleKeywords[groupName] : undefined;

        this.entityService.exportDataToCSV(
            Utils.IdBuilder.buildEntityID(this.divID, this.charTypeID, this.parentRecID),
            templateIDs,
            Consts.CharTypeIDs.right,
            sortData.sortField,
            sortData.sortDir,
            keywords,
            startDate,
            endDate,
            filters,
            this.selectedPaths,
            solrColumns)
            .then((result) => {
                this.csvExportJobID = result.jobID;
                this.startCSVExportProgress();
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    private startCSVExportProgress() {
        this.notifyService.startProgress();
        this.csvExportProgressIntervalPromise = this.$interval(() => this.updateCSVExportProgress(), 2000);
    }

    private updateCSVExportProgress() {
        this.adminService.getJobState(this.csvExportJobID).then((result) => {
            if (result.status === "Done" || result.status === "Failed" || result.status === "Cancelled") {
                this.$interval.cancel(this.csvExportProgressIntervalPromise);
                if (result.status === "Done") {
                    this.$window.location.assign(result.resultMessage);
                }

                if (result.status === "Failed") {
                    this.notifyService.notifyError(result.resultMessage);
                }

                this.notifyService.endProgress();
            }
        });
    }

    private getContactTitles(contctRecIDs: number[]): ng.IPromise<any> {
        let deferred = this.$q.defer();
        this.contactTitlesDictionary = {};
        var request: Models.ISearchResultByRecordIDsRequest = {
            charTypeID: Consts.CharTypeIDs.user,
            recordIDs: contctRecIDs.join(","),
            rowCount: contctRecIDs.length
        };
        if (contctRecIDs.length == 0) {
            return this.$q.when();
        } else {
            this.notifyService.startProgress();
            return this.entityService.getRecordDocumentsForRecordIDs(request)
                .then((result) => {
                    _.forEach(result.documents, (recordDocument) => {
                        this.contactTitlesDictionary[recordDocument.recordID] = recordDocument.title;
                    });
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    private associateSpecialColumns(row: Models.IListTableRow, that: this, recId: number) {
        _.forEach(row.columns, column => {
            let deal = that.rightsDealsDictionary[recId];
            let catalog = that.rightProperties[row.entityID];
            if (column.solrLabel === "deal_primary_contact" && deal.primaryContactId && deal.primaryContactName) {
                column.value = `<a href="/Contact/Details/${deal.primaryContactId}" target="_blank" title="Deal Source"><span>${deal.primaryContactName.toString()}</span></a>`;
            }
            if (column.solrLabel === "deal_title") {
                column.value = deal.dealName;
            }
            if (column.solrLabel === "deal_id") {
                column.value = `<a href="/Contract/Summary/${recId}" target="_blank" title="Deal Source"><span>${recId.toString()}</span></a>`;
            }
        });
    }

    private associateSpecialCatalogColumns(that: this) {
        _.forOwn(that.groupedRows, groupRows => {
            _.forEach(groupRows, row => {
                _.forEach(row.columns, column => {
                    let catalog = that.rightProperties[row.entityID];
                    if (catalog && column.solrLabel === "catalog_source") {
                        column.value = `<a href="/Asset/Details/${catalog.recID}" target = "_blank" title = "Source Catalog"> <span>${catalog.recID.toString()} </span></a>`;
                    }
                });
            });
        });
    }

    private getDeals(dealRecIds: number[]): ng.IPromise<any> {
        let deferred = this.$q.defer();
        this.notifyService.startProgress();
        var request: Models.ISearchResultByRecordIDsRequest = {
            charTypeID: Consts.CharTypeIDs.transaction,
            recordIDs: dealRecIds.join(","),
            rowCount: dealRecIds.length
        };
        let that = this;
        return this.entityService.getRecordDocumentsForRecordIDs(request)
            .then((result) => {
                _.forEach(result.documents, (recordDocument) => {
                    this.rightsDealsDictionary[recordDocument.recordID] = {
                        dealName: recordDocument.title,
                        primaryContactId: recordDocument.characteristics.primary_contact_id,
                        primaryContactName: recordDocument.characteristics.primary_contact
                    };
                });
                _.forOwn(that.groupedRows, groupRows => {
                    _.forEach(groupRows, row => {
                        let rightTransaction = this.rightTransactions[row.entityID];
                        if (rightTransaction) {
                            let recId = rightTransaction.recID;
                            this.associateSpecialColumns(row, that, recId);
                        }
                    });
                });
            }).finally(() => {
                this.notifyService.endProgress();
            });
    }

    GetRightsetTemplateColor(templateID: number): string {
        if (this.templateColors[templateID] != null) {
            return "border-left:8px solid " + this.templateColors[templateID];
        } else {
            return "";
        }
    }

    CopyDataDefaultSet(setID: string, entityID: string) {
        var relationshipID = this.rightsRelationshipIDs[entityID];
        if (!_.isEmpty(relationshipID)) {
            this.notifyService.startProgress();
            var relationshipRecID = Utils.IdBuilder.splitEntityID(relationshipID).recID;
            this.entityService.copyDataDefaultSet(setID, Consts.CharTypeIDs.relationship, relationshipRecID, false)
                .then((result) => {
                    this.forceRefresh = true;
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    DeleteDataDefaultSet(rightSetTemplateID: number, setID: string) {
        this.notifyService.startProgress();

        this.entityService.deleteDataDefaultSet(setID)
            .then((res) => {
                var index = -1;
                for (var i = 0; i < this.usageTemplateDataDefaultSets[rightSetTemplateID].length; i++) {
                    if (this.usageTemplateDataDefaultSets[rightSetTemplateID][i].id == setID) {
                        index = i;
                        break;
                    }
                }

                if (index > -1) {
                    this.usageTemplateDataDefaultSets[rightSetTemplateID].splice(index, 1);
                }
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    UpdateComponentSequence($event: ng.IAngularEvent, groupName: string, sortByCharTypeID: number) {
        $event.preventDefault();
        var templateID: number;
        var templateGroupID: number;
        var allowUpdateSequence: boolean = false;

        if (this.groupByMethod == "chartypeid") {
            templateID = -1;
            templateGroupID = -1;
            allowUpdateSequence = true;
        } else if (this.groupByMethod == "templateid") {
            var rights = this.groupedRows[groupName];
            if (rights.length > 0) {
                templateID = rights[0].templateID;
                templateGroupID = -1;
                allowUpdateSequence = true;
            }
        } else if (this.groupByMethod == "templategroupid") {
            var rights = this.groupedRows[groupName];
            if (rights.length > 0) {
                templateID = -1;
                templateGroupID = rights[0].templateGroupID;
                allowUpdateSequence = true;
            }
        }

        if (allowUpdateSequence) {
            this.notifyService.startProgress();
            this.entityService.updateComponentSequence(this.charTypeID, this.parentRecID, templateID, templateGroupID, Consts.CharTypeIDs.right, sortByCharTypeID)
                .then((result) => {
                    this.forceRefresh = true;
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            alert("No Rightset records to update sequence");
        }
    }

    public isSpecialColumn(column: Models.IListTableColumn): boolean {
        return this.listService.isSpecialColumn(column.solrLabel);
    }
    public isDealLinkVisible(row): boolean {
        return this.rightTransactions[row.entityID] && this.charTypeID !== Consts.CharTypeIDs.transaction;
    }

    private getSelectedTemplateIds(groupName: string): number[] {
        let contractRightTemplateIDs: number[] = [];
        _.forEach(this.selectedRights[groupName], (cr) => {
            if (contractRightTemplateIDs.indexOf(cr.templateID) == -1) {
                contractRightTemplateIDs.push(cr.templateID);
            }
        });

        return contractRightTemplateIDs;
    }

    public bulkCopyRights(groupName: string, $event: ng.IAngularEvent): void {
        $event.preventDefault();

        let contractRightTemplateIds = this.getSelectedTemplateIds(groupName);
        if (contractRightTemplateIds.length > 1) {
            alert("Bulk Copy can only be performed on records of the same Template.");
            return;
        }

        if (this.selectedRights[groupName].length > 40) {
            alert("Bulk Copy can only be performed with 40 or less selected rights. ");
            return;
        }

        this.notifyService.startProgress();
        let bulkCopyRequest: Models.IBulkCopyEntityRequest = {
            charTypeId: Consts.CharTypeIDs.right,
            recIds: this.selectedRights[groupName].map(entity => {
                let splitEntityId = IdBuilder.splitEntityID(entity.entityID);
                return splitEntityId.recID;
            }),
            templateId: contractRightTemplateIds[0],
            prefix: "NEW -- ",
            parentRecId: this.parentRecID
        };
        this.entityService.bulkCopyEntity(bulkCopyRequest).then((results) => {
            this.modalService.jobProgress(results.jobID, results.jobTitle, null, false, false, false).then(jobProgressResult => {
                if (jobProgressResult.status == "Done") {
                    let entitiesCreated = jobProgressResult.resultMessage.split(",");
                    this.selectedRights[groupName] = [];
                    return this.GetRights(groupName, this.getFilters(groupName)).then(() => {
                        entitiesCreated.forEach(entityId => {
                            this.selectRight(entityId);
                        });
                    }).then(() => {
                        return this.openEditRightsModal(groupName, entitiesCreated.map(entityId => {
                            let split = IdBuilder.splitEntityID(entityId);
                            return {
                                recID: split.recID,
                                charTypeID: split.charTypeID,
                                divID: split.divID
                            };
                        }));
                    });
                }
            });
        }).finally(() => {
            this.notifyService.endProgress();
        });
    }

    ClearSort(groupName: string, $event: ng.IAngularEvent) {
        this.groupPages[groupName].sortField = this.SORTFIELD_DEFAULT;
        this.groupPages[groupName].sortDir = 0;
    }

    //Drag and drop
    UpdateOrder(event) {
        console.log(event);
        var newOrderList: Models.IListTableRow[] = event.dest.sortableScope.modelValue;
        var recIDAndSequence: { [recID: number]: number } = {};
        var newSequenceNumber = -1;

        if (event.dest.index == 0) {
            //If we're at the beginning of the list, get the next sequence number and / 2
            var rowAtIndex = newOrderList[event.dest.index];
            var sequenceNumber = this.rightSetRecordSequence[rowAtIndex.recordID];
            newSequenceNumber = _.ceil(sequenceNumber / 2);
        }
        else if (event.dest.index + 1 == newOrderList.length) {
            //If we're at the end of the list, get the previous sequence number and add 4096
            var rowAtIndex = newOrderList[event.dest.index - 1];
            var sequenceNumber = this.rightSetRecordSequence[rowAtIndex.recordID];
            newSequenceNumber = _.ceil(sequenceNumber / 2);
        }
        else {
            //Get the destination index + 1 so we can calculate the new sequence number
            var itemBeforeIndex = newOrderList[event.dest.index - 1];
            var itemAfterIndex = newOrderList[event.dest.index + 1];
            newSequenceNumber = _.ceil((this.rightSetRecordSequence[itemBeforeIndex.recordID] + this.rightSetRecordSequence[itemAfterIndex.recordID]) / 2);
        }

        var recordID = newOrderList[event.dest.index].recordID;
        recIDAndSequence[recordID] = newSequenceNumber;
        this.rightSetRecordSequence[recordID] = newSequenceNumber;
        this.entityService.setRecordOrder(this.parentEntityId, Consts.CharTypeIDs.right, recIDAndSequence);
    };
}

interface IRightGrouping {
    right: Models.IListTableRow;
    groupName: string;
}

class BulkEditParameters {
    public constructor(
        public bulkEditRelationshipTitles: { [entityID: string]: { [charTypeID: number]: Models.IEntityRecIDTitle[] }; } = {},
        public bulkEditRightsetRels: { [rightSetEntityID: string]: Models.IEntityRelationship[] } = {},
        public bulkEditRightsetTrxRels: Models.IEntityRelationship[] = [],
        public templateIds: number[]
    ) {

    }
}